export const USE_ACCOUNTING_FLOW = 'use-accounting-flow';
export const SHOW_NET_RENTAL_INCOME = 'OP-display-NRI-for-accounting-users';
export const USE_OWNERS_PORTAL_GUEST_REPORT = 'DT-OP-guest-report';
export const USE_RENTAL_PERIOD_REQUEST_TO_BOOK =
  'DT-rental-period-request-to-book';
export const SHOW_REPORTS_PROPERTY_SELECTOR =
  'OP-reports-tab-properties-filter';
export const USE_REPORTS_DATE_RANGE = 'OP-owners-report-date-range';
export const USE_NEW_OWNER_RESERVATIONS =
  'OP-owner-reservations-to-actual-reservations';
export const USE_OWNERS_PORTAL_GUEST_REPORTS_CHANNEL =
  'owners_portal_guest_reports_channel';
export const HIDE_ZERO_CANCELED_REVENUE_BREAKDOWN =
  'OP-hide-zero-canceled-revenue-breakdown';
export const USE_RAS = 'OP-RAS-adoption';
export const USE_DOCUMENTS_PAGE = 'owners_gfp_documents_upload';
export const USE_OWNERS_HYDRA = 'use-owners-hydra';
